import { Grid, IconButton, InputBase, Paper, Typography } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import React, { useState, useEffect } from "react"

import CloseIcon from "@mui/icons-material/Close"
import useStyles from "./useStyles"
import MenuFilterTypeOrganization from "./MenuFilters/MenuFilterTypes"
import { useDispatch, useSelector } from "react-redux"

import {
  deleteSearchNameValue,
  deleteSearchValueOrg,
  getAllOrganizations,
  setSearchNameValue,
  setSelectedTypesOrg,
} from "../../../redux/actions/Organizations"

export const SearchBarAndFiltersOrganization = ({
  rows,
  setRows,
  setLoading,
  openFilterByType,
  setopenFilterByType,
  valueFilter,
  setvalueFilter,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [searchValue, setsearchValue] = useState("")
  const [buttonSearch, setbuttonSearch] = useState(false)
  const [orgsFilter, setorgsFilter] = useState([])
  const [types, setTypes] = useState([])
  const searchValueCUIT = useSelector(
    (state) => state.organization.searchValueCUIT,
  )
  //  const selectedTypes = useSelector((state) => state.organization.selectTypeFilter)
  const searchValueName = useSelector(
    (state) => state.organization.searchValueName,
  )
  // get organizations request
  // REEMPLAZAR POR CALLBACK EN ORGANIZATION TABLE
  const handleGetOrganizations = async () => {
    const response = await dispatch(getAllOrganizations())
    setRows(response)
  }
  // reset search value and valuefilter
  const resetValueSearch = async () => {
    setLoading(true)
    setvalueFilter(null)
    setsearchValue("")
    setopenFilterByType(false)
    dispatch(deleteSearchValueOrg())
    dispatch(deleteSearchNameValue())
    dispatch(deleteSearchValueOrg())
    dispatch(deleteSearchNameValue())
    await handleGetOrganizations()
    setLoading(false)
  }
  // add value default FALSE in types, for filter functionality use only
  const addValuesDefaultFilter = (types) => {
    const result = types.map((type) => {
      const obj = { name: type }
      obj.value = false
      return obj
    })
    return result
  }

  useEffect(() => {
    if (orgsFilter.length > 1) {
      getAllTypes()
    }
  }, [orgsFilter])

  //get types organization request
  const getAllTypes = async () => {
    const arr = []
    orgsFilter.forEach((element) => {
      if (!arr.includes(element.organizationType?.organizationTypeName)) {
        arr.push(element.organizationType?.organizationTypeName)
      }
    })
    arr && arr.length > 1
      ? setopenFilterByType(true)
      : setopenFilterByType(false)
    setTypes(addValuesDefaultFilter(arr))
  }

  // delete duplicate
  function getOrgsNoDuplicate(newarr) {
    return newarr.filter((item, index) => {
      const ifExists = (element) =>
        element.organizationId === item.organizationId
      return newarr.findIndex(ifExists) === index
    })
  }

  const handleFilterOrgs = (code) => {
    const actives = types.filter((element) => element.value)
    const codes = actives.map((element) => element.name)
    let arr = []
    if (codes.includes(code)) {
      const newtypes = types.map((element) => {
        if (element.name === code) {
          element.value = false
        }
        return element
      })
      setTypes(newtypes)
      dispatch(setSelectedTypesOrg(types))
      dispatch(setSelectedTypesOrg(types))
      arr = newtypes
    } else {
      const newtypes = types.map((element) => {
        if (element.name === code) {
          element.value = true
        }
        return element
      })
      setTypes(newtypes)
      dispatch(setSelectedTypesOrg(types))
      dispatch(setSelectedTypesOrg(types))
      arr = newtypes
    }
    let orgs = []
    const typesActive = arr.filter((element) => element.value)
    if (typesActive.length > 0) {
      typesActive.forEach((type) => {
        const result = orgsFilter.filter((element) => {
          return element.organizationType?.organizationTypeName === type.name
        })
        orgs = orgs.concat(result)
      })
      setRows(orgs)
    } else {
      setRows(orgsFilter)
    }
  }

  // change input search
  const handlechangeSearch = (event) => {
    setsearchValue(event.target.value)
    event.target.value !== "" ? setbuttonSearch(true) : setbuttonSearch(false)
  }

  const handleSearchSubmit = (event) => {
    if (
      event.type === "keydown" &&
      event.key === "Enter" &&
      searchValue !== ""
    ) {
      handleGetOrgsCandidates()
    }
  }

  const getOrgWithName = async (paramName) => {
    return await dispatch(getAllOrganizations(paramName))
  }
  const getOrgWithNameLegal = async (paramNameLegal) => {
    return await dispatch(getAllOrganizations(paramNameLegal))
  }
  useEffect(() => {
    if (searchValueName) {
      setvalueFilter(searchValueName)
      setsearchValue(searchValueName)
    } else {
      setsearchValue("")
    }
  }, [searchValueName])
  const handleGetOrgsCandidates = async () => {
    const valueToSearch = searchValue
    setLoading(true)
    let candidates = []

    const paramName = {
      organizationName: valueToSearch.toUpperCase(),
    }
    candidates = candidates.concat(await getOrgWithName(paramName))

    const paramNameLegal = {
      organizationLegalName: valueToSearch.toUpperCase(),
    }
    candidates = candidates.concat(await getOrgWithNameLegal(paramNameLegal))
    const orgs = getOrgsNoDuplicate(candidates)

    setRows(orgs)
    setvalueFilter(valueToSearch)
    dispatch(setSearchNameValue(searchValue))
    setorgsFilter(orgs)

    setLoading(false)
  }

  return (
    <Grid container className={classes.gridContainerInputSearch}>
      <Grid item xs={6} className={classes.gridCointanerInputSearch2}>
        <Paper className={classes.input}>
          <InputBase
            sx={{
              ml: 1,
              flex: 1,
            }}
            className={classes.inputBase}
            placeholder="Buscar por nombre o nombre legal"
            inputProps={{ "aria-label": "search" }}
            value={searchValue}
            onChange={handlechangeSearch}
            onKeyDown={handleSearchSubmit}
          />
          {buttonSearch ? (
            <Typography
              onClick={handleGetOrgsCandidates}
              className={classes.buttonSearchInput}
            >
              Buscar
            </Typography>
          ) : (
            <IconButton type="submit" sx={{ p: "10px" }} aria-label="search">
              <SearchIcon style={{ color: "#028B7E" }} />
            </IconButton>
          )}
        </Paper>
      </Grid>
      <Grid item xs={6} className={classes.gridMenuType}>
        {openFilterByType && (
          <div className={classes.menuType}>
            <Typography className={classes.typography}>Filtrar por:</Typography>
            <MenuFilterTypeOrganization
              types={types}
              handleFilterOrgs={handleFilterOrgs}
            />
          </div>
        )}
        {searchValueCUIT ? (
          <div
            style={{
              width: "60%",
              paddingLeft: "1%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <button
              className={classes.buttonResetFilter}
              onClick={resetValueSearch}
            >
              <Typography className={classes.typographyButton}>
                {searchValueCUIT}
              </Typography>
              <CloseIcon className={classes.closeIconButtonReset} />
            </button>
          </div>
        ) : valueFilter && valueFilter !== "" ? (
          <div
            style={{
              width: "60%",
              paddingLeft: "1%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <button
              className={classes.buttonResetFilter}
              onClick={resetValueSearch}
            >
              <Typography className={classes.typographyButton}>
                {valueFilter}
              </Typography>
              <CloseIcon className={classes.closeIconButtonReset} />
            </button>
          </div>
        ) : null}
      </Grid>
    </Grid>
  )
}
